<template>
  <div class="applePay">
    <div @click="processApplePay" id="applePay" class="apple-pay-button custom-styling"></div>
  </div>
</template>
<script>
import { apiUrl } from '@/constants';
import axios from 'axios';

export default {
  name: 'ApplePay',
  props: {
    merchant: {
      type: Object,
      require: true,
    },
    totalPrice: {
      type: Number,
      required: true,
    },
  },
  mounted() {
    this.showApplePay();
  },
  data: () => ({
    config: {
      currency_code: 'USD',
      country_code: 'US',
      display_name: 'Payarc',
      allowedCardNetworks: [
        'AMEX',
        'DISCOVER',
        'JCB',
        'MASTERCARD',
        'VISA',
      ],
    },
  }),
  methods: {
    showApplePay() {
      // Apple validates the top-level domain, so Apple Pay cannot work in an embed.
      if (!window.ApplePaySession || window.top !== window.self) {
        document.querySelector('.apple-pay-button').style.display = 'none';
      }
    },
    processApplePay() {
      const data = this.$store.state.PaymentForm;
      const subTotalDescr = this.merchant.name;
      const paymentRequest = {
        currencyCode: this.config.currency_code,
        countryCode: this.config.country_code,
        requiredShippingContactFields: ['postalAddress'],
        lineItems: [{ label: subTotalDescr, amount: this.totalPrice }, { label: 'P&P', amount: 0 }],
        total: {
          label: this.config.display_name,
          amount: this.totalPrice,
        },
        supportedNetworks: this.config.allowedCardNetworks,
        merchantCapabilities: ['supports3DS'],
      };
      const session = new ApplePaySession(3, paymentRequest);
      const self = this;
      session.onvalidatemerchant = (e) => {
        axios.post(`${apiUrl}/orders/auth-apple-merchant/`, {
          headers: {
            Authorization: `Bearer ${data.orderParams.orderToken}`,
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          u: e.validationURL,
        })
          .then((res) => {
            session.completeMerchantValidation(res.data);
          })
          .catch((err) => {
            console.error(err);
          });
      };
      session.onpaymentauthorized = (e) => {
        self.$emit('apple_payload', {
          paymentData: e.payment,
          callback: (result) => {
            const status = result ? ApplePaySession.STATUS_SUCCESS : ApplePaySession.STATUS_FAILURE;
            session.completePayment(status);
          },
        });
      };
      session.begin();
    },
  },
};
</script>
<style scoped>

@supports (-webkit-appearance: -apple-pay-button) {
    .apple-pay-button {
        display: inline-block;
        -webkit-appearance: -apple-pay-button;
        -apple-pay-button-type: pay;
        -apple-pay-button-style: black;
    }
}


@supports not (-webkit-appearance: -apple-pay-button) {
    .apple-pay-button {
        background-image: -webkit-named-image(apple-pay-logo-white);
        background-color: black;
        display: inline-block;
        background-size: 100% 60%;
        background-repeat: no-repeat;
        background-position: 50% 50%;
        border-radius: 5px;
        padding: 0px;
        box-sizing: border-box;
        min-width: 200px;
        min-height: 32px;
        max-height: 64px;
    }
}

.apple-pay-button.custom-styling {
    width: 100%;
    height: 40px;
    margin-bottom: 40px;
}

.apple-pay-button.custom-styling:hover {
    cursor: pointer;
}

</style>
